<template>
          <div class="box">
        <div class="contaner-title"><span>供应商管理</span> <span>/ 供应商列表</span></div>
        <div class="hr"></div>
        <Row >
            <Col span="3">
                <Input v-model="keyword" placeholder="请输入关键字" @on-enter="searchData"/>
            </Col>
                 <Col span="3">
             <Select v-model="userName" placeholder="认证状态" >
                 <img src="../../assets/status.png"  slot="prefix"  alt="">
                 <Option :value="4">全部</Option>
                 <Option :value="0">资料未完善</Option>
                 <Option :value="1">未认证</Option>
                 <Option :value="2">待审核</Option>
                 <Option :value="3">审核通过</Option>
            </Select>
            </Col>
            <Col span="1">
            <Button type="primary" ><icon size="20"  type="ios-search" @click.native="searchData" /></Button>
            </Col>
        </Row>
        <div class="tab">
              <Table  :row-class-name="rowClassName" :columns="columns1" :data="data1"></Table>
             <div style="text-align:right;padding:30px 0px;">
                  <Page :total="Count" @on-change="changePage" />
             </div>
        </div>
       <Modal  v-model="showDetail" :closable="false" width='765'>
           <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>用户详情</span>
               <img class="close" @click="showDetail=false" src="../../assets/close.png" alt="">
           </div>
            <div class="content-modal table-c">
                <Tabs value="name1">
                <TabPane label="基本信息" name="name1">
                    <table border="0" cellspacing="0" cellpadding="0">
                          <tr>
                               <td class="label" width="100">用户ID</td>
                                <td width="140">{{Detail.ID}}</td>
                                <td  class="label"  width="100">联系人</td>
                                <td width="140">{{Detail.Realname}}</td>
                                 <td  class="label"  width="100">手机号</td>
                                <td width="140">{{Detail.TelCode}} {{Detail.Tel}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">邮箱</td>
                                <td width="140">{{Detail.Email}}</td>
                                <td  class="label"  width="100">QQ</td>
                                <td width="140">{{Detail.QQ}}</td>
                                <td  class="label"  width="100">微信</td>
                                <td width="140">{{Detail.WX}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">认证状态</td>
                                <td width="140">
                                    <span v-if="Detail.Status==0">资料未完善</span>
                                    <span v-if="Detail.Status==1">未认证</span>
                                    <span v-if="Detail.Status==2">待审核</span>
                                    <span v-if="Detail.Status==3">审核通过</span>
                                </td>
                                <td  class="label"  width="100">供应商评级</td>
                                <td  width="140">{{Detail.SupplierRate}}</td>
                                <td  class="label"  width="100">完成项目数</td>
                                <td  width="140">{{Detail.FinishProjectNum.length}}</td>
                        </tr>
                         <tr>
                                <td  class="label" width="100">擅长项目</td>
                                <td  width="140" colspan="2"><span v-if="Detail.Fields" v-for="(ite,index) in Detail.Fields">{{ite}} ,</span></td>
                                <td  class="label"  width="100">累计完成金额</td>
                                <td  width="140" colspan="2">{{Detail.Amount_Total}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">技能标签</td>
                                <td width="140" colspan="5">{{Detail.Skill}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">工作地</td>
                                <td width="140" colspan="5">{{Detail.place}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">支付宝</td>
                                <td width="140" colspan="5">{{Detail.Alipay}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">银行卡号</td>
                                <td width="140" colspan="5" ><span v-if="Detail.Bank">{{Detail.Bank.Account}}</span></td>
                        </tr>
                          <tr>
                               <td class="label" width="100">户名</td>
                                <td width="140" colspan="5" ><span v-if="Detail.Bank">{{Detail.Bank.Name}}</span></td>
                        </tr>
                          <tr>
                               <td class="label" width="100">开户行</td>
                                <td width="140" colspan="5" ><span v-if="Detail.Bank">{{Detail.Bank.Username}}</span></td>
                        </tr>
                         <tr>
                               <td class="label" width="100">备注</td>
                                <td width="140" colspan="5">{{Detail.Comment}}</td>
                        </tr>
                    </table>
                </TabPane>
                <TabPane label="用户认证" name="name2">
                     <table border="0" cellspacing="0" cellpadding="0">
                        <tr>
                               <td class="label" width="100">供应商类型</td>
                                <td width="280" colspan="2"><span v-if="Detail.VerifyType==1">个人</span><span v-if="Detail.VerifyType==2">工作室 / 公司</span></td>
                                <td class="label"  width="100">规模</td>
                                <td width="280" colspan="2">{{Detail.Scale}}</td>
                        </tr>
                        <tr>
                               <td class="label" width="100">有效证件</td>
                                <td width="140" colspan="5"  height="119">
                                    <div v-if="Detail.Certificate">
                                        <img style=" width: 154px; height: 94px;cursor:pointer" @click="checkImg(item,index)" v-for="(item,index) in Detail.Certificate"  :src="imgUrl+item" alt="">
                                    </div>
                                </td>
                        </tr>
                        <tr>
                               <td class="label" width="100">企业名称</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.CompanyName}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业住所</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.CompanyAddress}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业法人</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.CompanyLeader}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">社会统一信用代码</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.CompanyCode}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业成立时间</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.CompanyDate}} 
                                    </div>
                                </td>
                        </tr>
                           <tr>
                               <td class="label" width="100">通讯地址</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.TelAddress}} {{Detail.DetailedAddress}}
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">联系人</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.ContactName}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">联系方式</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{Detail.ContactWay}} 
                                    </div>
                                </td>
                        </tr>
                        <tr>
                               <td class="label" width="100">项目经历</td>
                                <td width="140" colspan="5" height="108" style="text-align:left;vertical-align: initial;">{{Detail.ItemProcess}}</td>
                        </tr>
                        <tr>
                               <td class="label" width="100">作品展示</td>
                                <td width="140" colspan="5">
                                    <div v-if="Detail.FilePath" style="cursor:pointer;text-align:left;" >
                                        <p @click="download(item)" v-for="(item,index) in FilePath">{{item.Name}}  </p>
                                    </div>
                                </td>
                        </tr>
                        <tr>
                            <td class="label" width="100">供应商评级</td>
                            <td width="140" colspan="2">
                                <Select style="width:150px;" v-model="Detail.SupplierRate">
                                    <Option  value="一星">一星</Option>
                                    <Option  value="二星">二星</Option>
                                    <Option  value="三星">三星</Option>
                                    <Option  value="四星">四星</Option>
                                    <Option  value="五星">五星</Option>
                                </Select>
                            </td>
                                <td class="label" width="100">信息备注</td>
                            <td width="140" colspan="2">
                                <Input  style="width:150px;" v-model="Detail.Comment"></Input>
                            </td>
                        </tr>
                    </table>
                    <div style="margin:50px;text-align:center;padding:20px 0px">
                        <Button type="success" style="margin-right:20px;" @click="confirmVerify(3)" v-if="Detail.Status!=1&&Detail.Status!=0">认证通过</Button>
                        <Button type="error"  v-if="Detail.Status!=1&&Detail.Status!=0" @click="cancelVerify">取消认证</Button>
                    </div>
                </TabPane>
                <TabPane label="已完结" name="name3" class="tab">
                    <Table :row-class-name="rowClassName"  :columns="columns" :show-header="false" :data="data"></Table>
                </TabPane>
                <TabPane label="竞标中" name="name4"  class="tab">
                      <Table :row-class-name="rowClassName"  :columns="columns" :show-header="false" :data="data"></Table>
                </TabPane>
            </Tabs>
            </div>
           <div slot="footer">
               <Button type="info" @click="showDetail=false" >关闭</Button>
           </div>
       </Modal>
        <Modal v-model="showPortrait"  width="800">
                <div>
                        <Carousel  :value="valueProtrait" style="width:800px;" dots="outside" >
                                <CarouselItem v-for="(item,index) in Detail.Certificate" :key="index" style="width:800px;">
                                    <div class="demo-carousel">
                                        <img :src="imgUrl+item" style='width:100%;'/>
                                    </div>
                                </CarouselItem>
                        </Carousel>
                </div>
        </Modal>
        <Modal v-model="showRemark" :closable="false" >
            <div slot="header" class="header-modal">
                <span>取消认证</span>
                <img class="close" @click="showRemark=false" src="../../assets/close.png" alt="">
            </div>
            <div style="margin:20px;">
                <Input v-model="Remark"></Input>
            </div>
            <div slot="footer">
                <Button @click="showRemark=false" >关闭</Button>
                <Button type="success" @click="cancelVer" >确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            PID:'',
            showRemark:false,
            valueProtrait:0,
            showPortrait:false,
            imgUrl:this.$baseImg,
            showDetail:false,
            userName:'',//认证状态
             columns: [
                    {
                        title: '用户名',
                        key: 'Realname',
                        align:'left',
                        width:600,
                    },
                     {
                        title: '最后登录时间',
                        key: 'LastLoginTime',
                         align:'center',
                    }
                ],
                data:[{
                    name:'游戏模型场景模型三维动画制作建模3D动画视频特效     ',
                    date:'2019-12-12'
                },{
                    name:'游戏模型场景模型三维动画制作建模3D动画视频特效     ',
                    date:'2019-12-12'
                },{
                    name:'游戏模型场景模型三维动画制作建模3D动画视频特效     ',
                    date:'2019-12-12'
                },{
                    name:'游戏模型场景模型三维动画制作建模3D动画视频特效     ',
                    date:'2019-12-12'
                }],
              columns1: [
                    {
                        title: '联系人',
                        key: 'Realname',
                        align:'center',
                        width:120,
                    },
                     {
                        title: '认证状态',
                        key: 'Status',
                        width:120,
                         align:'center',
                         render:(h,params)=>{
                             var text="";
                             if(params.row.Status==0){
                                 text="资料未完善";
                             }else if(params.row.Status==1){
                                      text="未认证";
                             }else if(params.row.Status==2){
                                      text="待审核";
                             }else if(params.row.Status==3){
                                      text="审核通过";
                             }
                             return h('span',{
                                 style:{
                                     color:params.row.status==1?'#008C00':'#FF0000'
                                 }

                             },text)
                         }
                    },
                    {
                        title: '手机号',
                        key: 'Tel',
                        width:150,
                         align:'center',
                         render:(h,params)=>{
                             return h('span',{
                                 style:{
                                     
                                 }

                             },params.row.TelCode+params.row.Tel)
                         }
                    },
                     {
                        title: '企业名称',
                        key: 'CompanyName',
                         align:'center',
                         width:150
                    },
                    {
                        title: '擅长项目',
                        key: 'Fields',
                         align:'center',
                         render:(h,params)=>{
                             var arr=[];
                             if(params.row.Fields){
                                params.row.Fields.forEach(item=>{
                                      arr.push(h('span',{
                                 style:{
                                     
                                 }

                                    },item+','))
                                })
                             }
                        
                             return h('span',{
                                 style:{
                                     
                                 }

                             },arr)
                         }
                    },
                     {
                        title: '所在地',
                        key: 'Address',
                         width:180,
                         align:'center',
                         render:(h,params)=>{
                            //  console.log(this.$pcaa[86][330000])
                            //  console.log(this.$pcaa[330000][330100])
                            //  console.log(this.$pcaa[330100][330105])
                            var text='';
                            if(params.row.Address){
                                  text= this.$pcaa[86][params.row.Address.Province]+this.$pcaa[params.row.Address.Province][params.row.Address.City]+this.$pcaa[params.row.Address.City][params.row.Address.Area]
                            }
                               return h('span',{
                                    on:{
                                        "click":()=>{

                                        }
                                    }
                            },text)
                         }
                    },
                     {
                        title: '最后登录时间',
                        key: 'LastLoginTime',
                         align:'center',
                         width:200
                    },
                      {
                        title: '提醒',
                        key: 'RemindNum',
                         align:'center',
                         width:80
                    },
                    {
                        title: '操作',
                         align:'center',
                         width:200,
                        render:(h,params)=>{
                            if(params.row.Status==1||params.row.Status==0){
                                return h('div',[
                                    h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.getDetail(params.row)
                                                }
                                            }
                                        },'查看详情'),
                                        h('Button',{
                                            style:{
                                                   "margin-left":"10px"
                                            },
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.tips(params.row)
                                                }
                                            }
                                    },'提醒')
                                ])
                            }else{
                                if (this.PID) {
                                    return h('div',[
                                    h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.getDetail(params.row)
                                                }
                                            }
                                        },'查看详情'),
                                        h('Button',{
                                            style:{
                                                   "margin-left":"10px"
                                            },
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.invite(params.row)
                                                }
                                            }
                                        },'邀请竞标')
                                    ])
                                } else {
                                    return h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.getDetail(params.row)
                                                }
                                            }
                                    },'查看详情')
                                }
                            }
                         
                        }
                    },
                ],
                  data1: [],
                Count:0,
                page:1,
                pageSize:10,
                keyword:'',
                Detail:{FinishProjectNum:[]},
                Remark:'',
                UserID:0,
                FilePath:[],
        }
    },
    mounted(){
        this.PID = this.$route.query.PID;
        console.log(this.PID);
        this.getData();
    },
    methods:{
        //邀请竞标
        invite(row) {
            var params = {
                ProjectID : this.PID,
                MemberID : row.ID
            }
            this.$post('api/manage.ProjectManage/inviteProjectMember', params).then(res=>{
                if (res.code == 1) {
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        searchData(){
            this.page=1;
            this.getData();
        },
        changePage(val){
            this.page=val;
            this.getData();
        },
        tips(row){
           this.$Modal.confirm({
                    title: '提示',
                    content: '是否发送短信？',
                    onOk: () => {
                        var params={
                            Tel:row.Tel,
                            type:5
                            }
                            this.$post('api/Login/sendCode',params).then(res=>{
                                if(res.code==1){
                                    this.getData();
                                    this.$Message.success('发送成功')
                                }else{
                                    this.$Message.error(res.msg)
                                }
                            })
                    },
                    onCancel: () => {
                    }
                });
        },
        getData(){
            var params={
                page:this.page,
                pageSize:this.pageSize,
                keyword:this.keyword,
                Status:this.userName==4?'':this.userName
            }
            this.$post('api/manage.SupplierManage/supplierList',params).then(res=>{
                if(res.code==1){
                    this.data1=res.data.data;
                    this.Count=res.data.all_num;
                }
            })
        },
        download(item){
                const link = document.createElement('a');
                link.download = item.Path;
                link.href = this.imgUrl+item.Path;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        },
        confirmVerify(Status){//确认认证
        var params={
            ID:this.UserID,
            AuditComment:this.Remark,
            SupplierRate:this.Detail.SupplierRate,
            Comment:this.Detail.Comment,
            Status:Status
        }
        if(Status==3){
            if(!this.Detail.SupplierRate){
                 this.$Message.error('请给供应商评级');
                return false;
            }
        }
        this.$post('api/manage.SupplierManage/supplierAudit',params).then(res=>{
            if(res.code==1){
                if(Status==1){
                    this.Detail.Status=1;
                }
                this.showRemark=false;
                this.$Message.success(res.msg);
            }else{
                this.$Message.error(res.msg);
            }
        })
        },
        checkImg(item,index){
            this.valueProtrait=index;
            this.showPortrait=true;
        },
        cancelVer(){
            if(this.Remark){
                this.confirmVerify(1);
            }else{
                this.$Message.error('请输入取消认证的原因');
            }
        },
        cancelVerify(){//取消认证
             this.showRemark=true;
             this.Remark='';
        },
        getDetail(row){
            var params={
                ID:row.ID
            }
            this.UserID=row.ID;
            this.$post('api/manage.SupplierManage/supplierDetails',params).then(res=>{
                if(res.code==1){
                    this.showDetail=true;
                    this.Detail=res.data;
                
                    this.data=res.data.FinishProjectNum;
                    if(this.Detail.TelAddress){
                            // this.Detail.TelAddress=JSON.parse(res.data.TelAddress);
                         this.Detail.TelAddress=  this.$pcaa[86][res.data.TelAddress.Province]+this.$pcaa[res.data.TelAddress.Province][res.data.TelAddress.City]+this.$pcaa[res.data.TelAddress.City][res.data.TelAddress.Area]
                    }
                    // 
                    
                this.FilePath=[];
                if(res.data.FilePath){
                    res.data.FilePath.forEach(item=>{
                        if(item.split('.')[1]=='mp4'||item.split('.')[1]=='MP4'){
                            this.FilePath.push({Name:'视频',Path:item})
                        }else if(item.split('.')[1]=='pdf'){
                            this.FilePath.push({Name:'pdf',Path:item})
                        }
                    })
                }
                  
                    if(this.Detail.Address){ 
                       this.Detail.place=this.$pcaa[86][this.Detail.Address.Province]+this.$pcaa[this.Detail.Address.Province][this.Detail.Address.City]+this.$pcaa[this.Detail.Address.City][this.Detail.Address.Area]
                    }else{
                       this.Detail.place='';
                    }
                }
            })
        },
        rowClassName (row, index) {
                if ((index%2) === 1) {
                    return 'demo-table-info-row';
                } 
                return '';
            }
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
    height: 100%;
    >.ivu-row{
        margin-top: 20px;
        background-color: #fff;
        padding:20px 10px;
        box-shadow: 0px 3px 5px #D9DDE3;
        >.ivu-col{
            margin-right: 10px;
        }
    }
    .tab{
        height: calc(~"100% - 129px");
        margin-top: 20px;
        background-color: #fff;
        padding: 10px;
        box-shadow: 0px 3px 5px #D9DDE3;
    }
}
.table-c{
 table{
     border-right:1px solid #CAF2FF;border-bottom:1px solid #CAF2FF;
  td{
border-left:1px solid #CAF2FF;
padding:10px;
  text-align: center;
  border-top:1px solid #CAF2FF;
  font-size:12px;}
  .label{
      background-color: #F0FCFF;
      color: #0092C1;
  }
 } 
}
 .header-modal{
        padding:10px 15px;
        color: #fff;
        background-color: #01AAE3;
        font-size: 22px;
        display: flex;
        position: relative;
        span{
            margin-left: 20px;
            margin-top: 3px;
        }
        .close{
            width: 22px;
            height: 22px;
            position: absolute;
            right:14px;
            cursor: pointer;
            top:14px;
        }
    }
.content-modal{
    padding:20px;

}
.input-text{
    width: 100%;
    border-radius: 5px;
    border: 1px solid #eee;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/view/SupplierList/SupplierListInvite.vue